import { Grid2 } from '@mui/material';
import React from 'react';

import type { QuestionnaireModel } from 'generated/types';

import QuestionnaireField from './Field';

interface QuestionnaireFormProps {
  /** Questionnaire schema used to render inputs */
  data?: QuestionnaireModel;
  /** If provided, the form has an array of users. If not provided, the form is creating a single user */
  namePrefix?: string;
}

export default function QuestionnaireForm({
  data: questionnaire,
  namePrefix,
}: QuestionnaireFormProps) {
  const questions = questionnaire?.item?.map((question) => {
    const formName = namePrefix ? `${namePrefix}${question.linkId}` : undefined;

    return (
      <Grid2
        key={`questionnaire-${question.linkId}`}
        p={namePrefix ? 0 : 1}
        size={{ xs: 12, sm: 6 }}
      >
        <QuestionnaireField formName={formName} question={question} />
      </Grid2>
    );
  });

  // namePrefix is provided: Already within a Grid container
  // namePrefix is not provided: Need to create within a Grid container
  return (
    <>{namePrefix ? <>{questions}</> : <Grid2 container>{questions}</Grid2>}</>
  );
}
